import {AppRegistry} from 'react-native';
import {Main} from 'interface/Main';
import {setCookie} from 'utils/cookies';
import {isWeb} from 'utils/platform';

if (isWeb()) {
  const client = new URLSearchParams(window.location.search).get('client');
  if (client === 'android' || client === 'ios') {
    setCookie('mf_native_app', client);
  }
}

AppRegistry.registerComponent('RXApp', () => Main);
AppRegistry.runApplication('RXApp', {rootTag: document.getElementById('root')});
